import React, {Component} from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import styles from './styles.module.scss';
import TitleView from 'shared_features/title';

const MAX_DESCRIPTION_LENGTH = 10000;

export default class View extends Component {

    render() {
        const notesLength = (this.props.notes || '').length;
        const isOverLimit = notesLength > MAX_DESCRIPTION_LENGTH;

        return (
            <div>
                <TitleView title={this.props.name}
                    isEditable={this.props.isEditable}
                    updateTitle={(text)=>this.props.updateProgramName(this.props.match.params.programid, text)}
                    saveTitle={()=>this.props.saveProgramName(this.props.match.params.programid, this.props.name)} />
                <div className={styles.notesContainer}>
                    <TextareaAutosize
                        className={`${styles.notes} ${isOverLimit ? styles.notesError : ''}`}
                        minRows={2}
                        maxRows={6}
                        value={this.props.notes || ''}
                        placeholder="Add description..."
                        onChange={(event)=>this.props.updateProgramNotes(this.props.match.params.programid, event.target.value)}
                        onBlur={()=>{
                            const currentLength = (this.props.notes || '').length;
                            if (currentLength <= MAX_DESCRIPTION_LENGTH) {
                                this.props.saveProgramNotes(this.props.match.params.programid, this.props.notes);
                            }
                        }} />
                    <div className={`${styles.charCounter} ${isOverLimit ? styles.charCounterError : ''}`}>
                        {notesLength.toLocaleString()} / {MAX_DESCRIPTION_LENGTH.toLocaleString()}
                    </div>
                </div>
            </div>
        );
    }
};
